/** FAQ content loaded from docs/USER_FAQ.md (single source of truth). */
import userFaqMarkdown from '../../../docs/USER_FAQ.md?raw';
import { parseUserFaqMarkdown } from './parseUserFaq.js';

export const HELP_FAQ_SECTIONS = parseUserFaqMarkdown(userFaqMarkdown);
